import { useContext, useEffect } from "react";
import { useTracking } from "react-tracking";
import useAuthentication from "../../../hooks/useAuthentication";
import { useTranslation } from "react-i18next";
import NavbarItemsContext from "../../../contexts/navbarItemsContext";

const HomeContainer = () => {
  const { t } = useTranslation();
  const { trackEvent } = useTracking();
  const auth = useAuthentication();
  const context = useContext(NavbarItemsContext);

  useEffect(() => {
    context.setSelectedIndex(-1);
    trackEvent({
      page: "home",
      event: "page-load",
    });
  }, []);

  return (
    <div className="w-full text-center bg-adq-blue">
      <h1 className="text-6xl font-normal leading-[104px] text-white w-2/3 mx-auto py-[10%]">
        {t("welcome.message", { fullname: auth.userLogged().fullname })}
      </h1>
    </div>
  );
};

export default HomeContainer;
